import fetcher from '../../utils/api';

export const fetchForDocumentMetadata = async (scribeId: string) => {
  return fetcher(`document_metadata/${scribeId}/sharing`, 'GET', true);
};
